<template>
    <header :class="{ 'app-header-inter-pages': isHeaderElevated }"
        class="py-12 px-xl-12 fixed-top app-header">
        <NuxtLayout name="header" />
    </header>
        <slot />
        <ClientOnly>
            <NuxtLayout name="footer">
                <NuxtLayout name="marks-footer"/>
            </NuxtLayout>
        </ClientOnly>
        <ClientOnly>
            <UiElementContactEmbed/>
        </ClientOnly>
</template>

<script setup>
import { useWindowScroll, throttleFilter } from "@vueuse/core";
  
const isHydrated = ref(false);
const { y } = useWindowScroll({
  eventFilter: throttleFilter(100),
});
const isHeaderElevated = computed(() => isHydrated.value && y.value >= 70);

onMounted(() => {
  isHydrated.value = true;
});

</script>

<style lang="scss" scoped>

</style>
